<template>
  <div>
    <v-btn 
      :class="[
        'btn-primary-momentos-security',
        'text-12-security',
        { 'btn-active-momentos-security': type === category }
      ]"
      v-for="(type, idx) in types" 
      :key="idx" 
      :id="type"
      @click="$emit('type', type)"
    >
      {{ type }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    types: {
      type: Array,
      required: false
    },
    category: {
      type: String,
      required: false
    }
  },
}
</script>

<style>
.btn-primary-momentos-security {
  border-radius: 8px;
  height: 25px;
  margin-right: 0 !important;
}

.btn-active-momentos-security {
  background: #28385C !important;
  border-color: #28385C !important;
  color: white !important;
  font-weight: 700;
}
</style>
